
import { Reducer, Action } from 'redux';
import {
    VISIT_CONCEPTS_REQUEST,
    VISIT_CONCEPTS_SUCCESS,
    VISIT_CONCEPTS_FAILURE,
    VISIT_CONCEPTS_CLEAR,
    VisitConceptsActionTypes
} from '../actions/VisitConcepts.Actions';
import { VisitConceptsState, VisitConceptsUnloadState } from '../states/VisitConceptsState';

type KnownAction =
    | { type: typeof VISIT_CONCEPTS_REQUEST; isLoading?: boolean; isLoadingSuccess?: boolean; failLoading?: boolean; protocolId?: number; visitId?: number; patientId?: number }
    | { type: typeof VISIT_CONCEPTS_SUCCESS; isLoading?: boolean; isLoadingSuccess?: boolean; failLoading?: boolean; payload: any }
    | { type: typeof VISIT_CONCEPTS_FAILURE; isLoading?: boolean; isLoadingSuccess?: boolean; failLoading?: boolean; error: any }
    | { type: typeof VISIT_CONCEPTS_CLEAR }
    ;

export const visitConceptsReducer: Reducer<VisitConceptsState> = (
    state: VisitConceptsState | undefined,
    incomingAction: Action
): VisitConceptsState => {
    if (state === undefined) {
        return VisitConceptsUnloadState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case VISIT_CONCEPTS_REQUEST:
            return {
                ...state,
                isLoading: action.isLoading ?? true,
                isLoadingSuccess: action.isLoadingSuccess,
                failLoading: action.failLoading ?? false,
                error: null,
                protocolId: (action as any).protocolId,
                visitId: (action as any).visitId,
                patientId: (action as any).patientId
            };
        case VISIT_CONCEPTS_SUCCESS:
            return {
                ...state,
                isLoading: action.isLoading ?? false,
                isLoadingSuccess: action.isLoadingSuccess ?? true,
                failLoading: action.failLoading ?? false,
                data: (action as any).payload,
                error: null
            };
        case VISIT_CONCEPTS_FAILURE:
            return {
                ...state,
                isLoading: action.isLoading ?? false,
                isLoadingSuccess: action.isLoadingSuccess ?? false,
                failLoading: action.failLoading ?? true,
                error: (action as any).error
            };
        case VISIT_CONCEPTS_CLEAR:
            return VisitConceptsUnloadState;
        default:
            return state;
    }
};
